import {callIfFn} from "src/components/Planner/planner/history";
import { PlannerAction } from "src/components/Planner/planner/history/planner-action";
import {ts} from "src/utils/translate"
import { getDeviceById, getNote, getNoteById, uDev } from "src/components/Planner/planner/uDev";
import {
  deleteDevNote,
  deleteSoleNote,
  modDevNote,
  modSoleNote,
  sendDevNoteAuto,
  sendSoleNote,
  uDevDOM
} from "src/components/Planner/planner/uDev-dom";
import {PlannerGlobals} from "src/components/Planner/planner/planner-globals";
import {redrawDevice} from "src/components/Planner/planner/deviceDrawing";
import {redrawNotes} from "src/components/Planner/planner/notes";

export class CreateSoleNoteAction extends PlannerAction {
  constructor(id, x, y, text, color) {
    super();
    this.actionName = ts("p_do_action_note_new", "Creating note");
    this.id = id;
    this.x = x;
    this.y = y;
    this.text = text;
    this.color = color;
  }
  execute(callback) {
    var thisVar = this;
    var preId = this.id;
    sendSoleNote(this.x, this.y, this.text, this.color, function (note) {
      if (note) {
        thisVar.id = note.note_id
        PlannerGlobals.plannerHistoryManager.noteIdChanged(preId, thisVar.id);

        callIfFn(callback, true);
      }
      else {
        callIfFn(callback, false);
      }
    });
  }
  undo(callback) {
    deleteSoleNote(this.id, function (res) {
      if (res) {
        redrawNotes();
        callIfFn(callback, true);
      }
      else {
        callIfFn(callback, false);
      }
    });
  }
  noteIdChanged(from, to) {
    if (this.equalAsString(this.id, from)) {
      this.id = to;
    }
  }
}

export class CreateDevNoteAction extends PlannerAction {
  /**
   *
   * @param {number | string} deviceId
   * @param {string} text
   * @param {string} color
   */
  constructor(deviceId, text, color) {
    super();
    this.actionName = ts("p_do_action_note_new", "Creating note");
    this.deviceId = deviceId;
    this.text = text;
    this.color = color;
  }
  execute(callback) {
    var dev = getDeviceById(this.deviceId);
    if (!dev) { return callIfFn(callback, false); }
    var oriNoteId = dev.noteId;
    sendDevNoteAuto(this.deviceId, this.text, this.color, function (res) {
      if (res) {
        PlannerGlobals.plannerHistoryManager.noteIdChanged(oriNoteId, res.noteId);
      }
      callIfFn(callback, !!res);
    });
  }
  undo(callback) {
    var dev = getDeviceById(this.deviceId);
    if (!dev) { return callIfFn(callback, false); }
    deleteDevNote(dev, function (res) {
      redrawDevice(dev.deviceId);
      callIfFn(callback, !!res);
    });
  }
  deviceIdChanged(from, to) {
    if (this.equalAsString(this.deviceId, from)) {
      this.deviceId = to;
    }
  }
}

export class DragSoleNoteAction extends PlannerAction {
  /**
   *
   * @param {number} id
   * @param {Point} fromPt
   * @param {Point} toPt
   */
  constructor(id, fromPt, toPt) {
    super();
    this.actionName = ts("p_do_action_note_move", "Moving note");
    this.id = id;
    this.fromPt = fromPt;
    this.toPt = toPt;
  }
  moveNoteTo(pt, callback) {
    var note = getNoteById(this.id);
    if (!note) { return callIfFn(callback, false); }
    uDevDOM.postItAjax.modifyDrag(this.id, pt.x, pt.y, function () {
      note.x = pt.x;
      note.y = pt.y;
      redrawNotes();
      callIfFn(callback, true);
    }, function () {
      callIfFn(callback, false);
    });
  }
  execute(callback) {
    this.moveNoteTo(this.toPt, callback);
  }
  undo(callback) {
    this.moveNoteTo(this.fromPt, callback);
  }
  noteIdChanged(from, to) {
    if (this.equalAsString(this.id, from)) {
      this.id = to;
    }
  }
}

export class ModifyNoteAction extends PlannerAction {
  /**
   *
   * @param {number | string} id
   * @param {string} fromText
   * @param {string} fromColor
   * @param {string} toText
   * @param {string} toColor
   * @param {"dev" | "sole"} type
   */
  constructor(id, fromText, fromColor, toText, toColor, type) {
    super();
    this.actionName = ts("p_do_action_note_mod", "Modifying note");
    this.id = id;
    this.fromText = fromText;
    this.fromColor = fromColor;
    this.toText = toText;
    this.toColor = toColor;
    this.type = type;
  }
  modifyNote(text, color, callback) {
    var note = getNote(this.id, this.type);
    if (this.type === "dev") {
      var dev = getDeviceById(this.id);
      modDevNote(dev, color, text, function (dev) {
        callIfFn(callback, !!dev);
      });
    }
    else {
      modSoleNote(note, color, text, function (note) {
        callIfFn(callback, !!note);
      });
    }
  }
  execute(callback) {
    this.modifyNote(this.toText, this.toColor, callback);
  }
  undo(callback) {
    this.modifyNote(this.fromText, this.fromColor, callback);
  }
  noteIdChanged(from, to) {
    if (this.equalAsString(this.id, from)) {
      this.id = to;
    }
  }
  deviceIdChanged(from, to) {
    if (this.type === "dev" && this.equalAsString(from, this.id)) {
      this.id = to;
    }
  }
}

export class DeleteSoleNoteAction extends PlannerAction {
  constructor(id, x, y, text, color) {
    super();
    this.actionName = ts("p_do_action_note_del", "Deleting note");
    this.id = id;
    this.x = x;
    this.y = y;
    this.text = text;
    this.color = color;
  }
  execute(callback) {
    deleteSoleNote(this.id, function (res) {
      if (res) {
        redrawNotes();
        callIfFn(callback, true);
      }
      else {
        callIfFn(callback, false);
      }
    });
  }
  undo(callback) {
    var thisVar = this;
    var preId = this.id;
    sendSoleNote(this.x, this.y, this.text, this.color, function (note) {
      if (note) {
        thisVar.id = note.note_id
        PlannerGlobals.plannerHistoryManager.noteIdChanged(preId, thisVar.id);

        callIfFn(callback, true);
      }
      else {
        callIfFn(callback, false);
      }
    });
  }
  noteIdChanged(from, to) {
    if (this.equalAsString(this.id, from)) {
      this.id = to;
    }
  }
}

export class DeleteDevNoteAction extends PlannerAction {
  /**
   *
   * @param {number} deviceId
   * @param {string} text
   * @param {string} color
   */
  constructor(deviceId, noteId, text, color) {
    super();
    this.actionName = ts("p_do_action_note_del", "Deleting note");
    this.deviceId = deviceId;
    this.noteId = noteId;
    this.text = text;
    this.color = color;
  }
  execute(callback) {
    var dev = getDeviceById(this.deviceId);
    if (!dev) { return callIfFn(callback, false); }

    deleteDevNote(dev, function (res) {
      redrawDevice(dev.deviceId);
      callIfFn(callback, !!res);
    });
  }
  undo(callback) {
    var dev = getDeviceById(this.deviceId);
    if (!dev) { return callIfFn(callback, false); }
    var oriNoteId = this.noteId;
    sendDevNoteAuto(this.deviceId, this.text, this.color, function (res) {
      if (res) {
        PlannerGlobals.plannerHistoryManager.noteIdChanged(oriNoteId, res.noteId);
      }
      callIfFn(callback, !!res);
    });
  }
  deviceIdChanged(from, to) {
    if (this.equalAsString(this.deviceId, from)) {
      this.deviceId = to;
    }
  }
  noteIdChanged(from, to) {
    if (this.equalAsString(this.noteId, from)) {
      this.noteId = to;
    }
  }
}
